//local imports
import { Messenger } from "@app/shared";

import { ToastLevel, ToastMessage } from "@app/components";
import {
  CatalogStateService, 
  DepartmentModel,
  DepartmentAddedMessage,
  DepartmentUpdatedMessage,
  RefreshFilterMessage,
} from "@app/catalog";

import {
  DepartmentCreatedNotification,
  DepartmentUpdatedNotification
} from "@app/catalog-common";

export class DepartmentStateHandler {
  public initialize(
    catalogStateService: CatalogStateService,
    messenger: Messenger,
  ) {
    //TODO:DIW:Moving message handling for entities into SRP classes
    messenger.subscribe(
      catalogStateService,
      DepartmentCreatedNotification,
      (message: DepartmentCreatedNotification) => {
        let newDepartment = new DepartmentModel();

        newDepartment.id = message.id;

        newDepartment.name.set(message.name);

        this.updateDepartment(newDepartment, message);

        catalogStateService.CatalogManagementState.departments.set([
          newDepartment,
          ...catalogStateService.CatalogManagementState.departments(),
        ]);

        messenger.send(
          ToastMessage.create(
            new DepartmentAddedMessage(newDepartment),
            ToastLevel.Information,
          ),
        );
        messenger.send(new RefreshFilterMessage());
      },
    );

    messenger.subscribe(
      catalogStateService,
      DepartmentUpdatedNotification,
      (message: DepartmentUpdatedNotification) => {
        let department =
          catalogStateService.CatalogManagementState.departments().find(
            (u) => u.id === message.id,
          );

        if (!department) {
          department = new DepartmentModel();
          department.id = message.id;

          department.name.set(message.name);
        }

        this.updateDepartment(department, message);

        messenger.send(new RefreshFilterMessage());
        messenger.send(
          ToastMessage.create(
            new DepartmentUpdatedMessage(department),
            ToastLevel.Information,
          ),
        );
      },
    );
  }

  private updateDepartment(
    department: DepartmentModel,
    message: DepartmentCreatedNotification | DepartmentUpdatedNotification,
  ) {
    //TODO:DIW:Move into it's own class..
    //TODO:DIW:Set properties by reading changed properties collection and mapping..

    for (let change of message.changes) {
      if (change.propertyName.toLowerCase() === "name") {
        department.name.set(change.newValue);
      }
    }
  }
}
